import { environment } from './../../environments/environment';
import { OccConfig } from '@spartacus/core';
export const defaultKnBrOccAsmConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        asmCustomerSearch: environment.PREFIX + environment.BASE_SITE[0] + '/salesreps',
      },
    },
  },
};
